import { JsonObject, JsonProperty } from 'json2typescript'
import { HubtypeCase } from 'models/hubtype-case'

@JsonObject
export class HubtypeCaseTransferEvent {
  @JsonProperty('previous_queue_id', String, true)
  public previous_queue_id?: string = undefined

  @JsonProperty('current_queue_name', String, true)
  public current_queue_name?: string = undefined

  @JsonProperty('current_project_name', String, true)
  public current_project_name?: string = undefined

  @JsonProperty('previous_assigned_user_id', String, true)
  public previous_assigned_user_id?: string = undefined

  @JsonProperty('user_executor_id', String, true)
  public user_executor_id?: string = undefined

  @JsonProperty('user_executor_name', String, true)
  public user_executor_name?: string = undefined

  @JsonProperty('case', HubtypeCase, true)
  public case?: HubtypeCase = undefined
}
